

(function(){
    angular.module('app.widgets')
        .directive('obtList2FormItem', obtList2FormFn);

    function obtList2FormFn(){

        return {
            restrict: 'E',
            scope:{
                isCreateMode:'@?',
                data:'=?listModel',
                chan : '=?changeVar'
            },
            templateUrl:'./../../app/widgets/section2formItem/section2FormItem.directive.html',
            controller:updatePageSectionType2Ctrl
        };
    }
    /*@ngInject*/
    function updatePageSectionType2Ctrl($scope){
        //$scope.newItem = null;
        $scope.data = $scope.data || [];

        $scope.addNewItem = addNewItem;
        $scope.deleteItem = deleteItem;
        $scope.moveUpItem = moveUpItem;
        $scope.moveDownItem = moveDownItem;

        function addNewItem(newItem){
            if (newItem){
                $scope.data.push(newItem);
                if ($scope.chan === true){
                    $scope.chan=false;
                }
                newItem = '';
            }
        }

        function move(items, from,to){
            if(items){
                items.splice(to,0,items.splice(from,1)[0]);
                if ($scope.chan === true){
                    $scope.chan=false;
                }
            }
            return items;
        }

        function moveUpItem(item){
            var index = $scope.data.indexOf(item);
            move($scope.data, index, index-1);
            if ($scope.chan === true){
                $scope.chan=false;
            }
        }
        function moveDownItem(item){
            var index = $scope.data.indexOf(item);
            move($scope.data, index, index+1);
            if ($scope.chan === true){
                $scope.chan=false;
            }
        }
        function deleteItem(item){
            if($scope.data && item){
                $scope.data.splice($scope.data.indexOf(item), 1);
                if ($scope.chan === true){
                    $scope.chan=false;
                }
            }
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/section2formItem/section2FormItem.directive.js
 ** module id = 197
 ** module chunks = 0
 **/